<template>
    <div>
        <form action="">
            <CharacterField v-if="question.type === 'character'"
                            :question="question"
                            :answer="answer"
                            :questionLabel="questionLabel"
                            :hasError="hasError"></CharacterField>

            <FunctionNameField v-else-if="question.type === 'function_name'"
                               :question="question"
                               :answer="answer"
                               :questionLabel="questionLabel"
                               :hasError="hasError"></FunctionNameField>

            <div class="row radio-buttons was-validated" v-else-if="question.field_type === 'radio'">
                <label class="col-sm-5 col-form-label">
                    {{questionLabel}}
                    <span class="required-star" v-if="+question.field_required">*</span>
                    <i v-if="question.info.length" class="fa fa-info-circle fa-lg" data-toggle="tooltip"
                       data-placement="top" :title="question.info"></i>
                </label>
                <div class="col-md-7">
                    <label v-bind:key="key" class="label-check"
                           v-for="(option, key) in question.extraAttributes.questionOptions">{{option.option_label}}
                        <input type="radio" :value="option.option_value" v-model="answer.value"/>
                        <span class="checkmark"></span>
                    </label>
                    <div v-if="hasError" class="radio-error-message">Kies een optie</div>
                </div>
            </div>

            <div class="row checkboxes was-validated" v-else-if="question.field_type === 'checkbox'">
                <label class="col-sm-5 col-form-label">
                    {{questionLabel}}
                    <span class="required-star" v-if="+question.field_required">*</span>
                    <i v-if="question.info.length" class="fa fa-info-circle fa-lg" data-toggle="tooltip"
                       data-placement="top" :title="question.info"></i>
                </label>
                <div class="col-sm-7">
                    <div class="checkbox-holder" v-bind:key="key"
                         v-for="(option, key) in question.extraAttributes.questionOptions">
                        <div class="checkbox-slider">
                            <label class="switch">
                                <input type="checkbox" :value="option.option_value" v-model="answer.value">
                                <span class="slider round"></span>
                            </label>
                        </div>
                        <div class="checkbox-slider-text">
                            <span class="label-text">{{option.option_label}}</span>
                        </div>
                    </div>

                    <div v-if="hasError" class="radio-error-message">Kies een optie</div>
                </div>
            </div>

            <div class="row" v-else-if="question.field_type === 'select'">
                <label class="col-sm-5 col-form-label">
                    {{questionLabel}}
                    <span class="required-star" v-if="+question.field_required">*</span>
                    <i v-if="question.info.length" class="fa fa-info-circle fa-lg" data-toggle="tooltip"
                       data-placement="top" :title="question.info"></i>
                </label>
                <div class="col-sm-7">
                    <div class="form-group">
                        <div class="senioriteit-wrap3">
                            <!--<img src="@/assets/img/drop.png" class="drop3">-->
                            <select class="form-control" v-model="answer.value" v-bind:value="answer.value"
                                    v-bind:class="{ 'is-invalid': hasError }" >
                                <option value="">-Kies een optie-</option>
                                <option v-bind:key="key" :value="option.option_value"
                                        v-for="(option, key) in question.extraAttributes.questionOptions">
                                    {{option.option_label}}
                                </option>
                            </select>
                            <div v-if="hasError" class="invalid-feedback">Dit veld is verplicht</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row form-group " v-else-if="question.field_type === 'textarea'">
                <label class="col-sm-5 col-form-label">
                    {{questionLabel}}
                    <span class="required-star" v-if="+question.field_required">*</span>
                    <i v-if="question.info.length" class="fa fa-info-circle fa-lg" data-toggle="tooltip"
                       data-placement="top" :title="question.info"></i>
                </label>
                <div class="col-sm-7">
                    <textarea rows="3" :placeholder="question.field_placeholder"

                              v-bind:class="{ 'is-invalid': hasError }"
                              class="txt-area form-control" v-model="answer.value"></textarea>
                    <div v-if="hasError" class="invalid-feedback">Dit veld is verplicht</div>
                </div>
            </div>

            <div class="row" v-else-if="question.field_type === 'number'">
                <label for=""
                       class="col-sm-5 col-form-label">
                    {{questionLabel}}
                    <span class="required-star" v-if="+question.field_required">*</span>
                    <i v-if="question.info.length" class="fa fa-info-circle fa-lg" data-toggle="tooltip"
                       data-placement="top" :title="question.info"></i>
                </label>
                <div class="col-sm-7">
                    <div class="form-group">
                        <input type="number" step="1" class="form-control "
                               min="0"
                               max="99999"
                               onkeydown="javascript: return event.keyCode == 69 || event.keyCode == 188 || event.keyCode == 110 || event.keyCode == 190 ? false : true"
                               v-on:keydown.enter.prevent=""
                               v-bind:class="{ 'is-invalid': hasError }"
                               :placeholder="question.field_placeholder" v-model="answer.value">
                        <div v-if="hasError && answer.value !== ''" class="invalid-feedback">
                            Dit veld moet een nummerieke waarde bevatten
                        </div>
                        <div v-else-if="hasError" class="invalid-feedback">
                            Dit veld is verplicht
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-else-if="question.field_type === 'date'">

                <label for=""
                       class="col-sm-5 col-form-label">
                    {{questionLabel}}
                    <span class="required-star" v-if="+question.field_required">*</span>
                    <i v-if="question.info.length" class="fa fa-info-circle fa-lg" data-toggle="tooltip"
                       data-placement="top" :title="question.info"></i>
                </label>
                <div class="col-sm-7">
                    <div class="form-group">
                        <date-picker v-model="answer.value" :config="datePickerOptions"></date-picker>
                        <div v-if="hasError && answer.value !==''" class="invalid-feedback">Vul een geldige numerieke
                            waarde in
                        </div>
                        <div v-else-if="hasError" class="invalid-feedback">Dit veld is verplicht</div>
                    </div>
                </div>
            </div>
            <div class="row" v-else-if="question.field_type === 'datetime-local'">

                <label for=""
                       class="col-sm-5 col-form-label">
                    {{questionLabel}}
                    <span class="required-star" v-if="+question.field_required">*</span>
                    <i v-if="question.info.length" class="fa fa-info-circle fa-lg" data-toggle="tooltip"
                       data-placement="top" :title="question.info"></i>
                </label>
                <div class="col-sm-7">
                    <div class="form-group">
                        <date-picker v-model="answer.value" :config="dateTimePickerOptions"></date-picker>
                        <div v-if="hasError && answer.value !==''" class="invalid-feedback">Vul een geldige numerieke
                            waarde in
                        </div>
                        <div v-else-if="hasError" class="invalid-feedback">Dit veld is verplicht</div>
                    </div>
                </div>
            </div>


            <div class="row" v-else>
                <label for=""
                       class="col-sm-5 col-form-label">
                    {{questionLabel}}
                    <span class="required-star" v-if="+question.field_required">*</span>
                    <i v-if="question.info.length" class="fa fa-info-circle fa-lg" data-toggle="tooltip"
                       data-placement="top" :title="question.info"></i>
                </label>
                <div class="col-sm-7">
                    <div class="form-group">
                        <input :type="question.field_type" class="form-control "
                               v-on:keydown.enter.prevent=""
                               v-bind:class="{ 'is-invalid': hasError }"
                               :placeholder="question.field_placeholder" v-model="answer.value">
                        <div v-if="hasError" class="invalid-feedback">Dit veld is verplicht</div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
  import CharacterField from './CharacterField'
  import FunctionNameField from './FunctionNameField'
  import {mapGetters} from 'vuex'
  import $ from 'jquery'

  // datetimepicker
  import DatePicker from 'vue-bootstrap-datetimepicker'
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

  export default {
    name: 'Field',
    components: {
      CharacterField,
      FunctionNameField,
      DatePicker
    },

    methods: {},
    props: ['question', 'answer'],
    data () {
      return {
        datePickerOptions: {
          format: 'DD/MM/YYYY',
        },
        dateTimePickerOptions: {
          format: 'DD/MM/YYYY H:m',
        },
      }
    },
    mounted () {
      // initialize tooltips
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })

      if (this.question.field_type === 'checkbox' && this.answer.value === '') {
        this.answer.value = []
      }

      if (this.question.field_type === 'radio' && this.answer.value === '') {
        if (typeof this.question.extraAttributes.questionOptions[0] !== 'undefined') {
          this.answer.value = this.question.extraAttributes.questionOptions[0].option_value
        }
      }
    },
    computed: {
      ...mapGetters({
        questions: 'question/getCurrentQuestions',
        currentStep: 'question/getCurrentStep',
        totalSteps: 'question/getTotalSteps',
        error: 'question/hasError',
      }),
      hasError () {
        return this.$store.getters['question/hasErrorByQuestionId'](this.question.id)
      },
      questionLabel () {
        return this.$store.getters['question/getQuestionLabel'](this.question)
      }
    },
  }
</script>

<style lang="scss" scoped>
    .wrap-block7 {
        margin-top: 50px;
        padding: 0 40px 0 40px;
    }

    .wrapblc1 {
        background-image: url(../../../assets/img/analytisch.png);
        background-position: center;
        background-size: cover;
    }

    .wrapblc2 {
        background-image: url(../../../assets/img/communicatief.png);
        background-size: cover;
        background-position: center;
    }

    .wrapblc3 {
        margin-top: 20px;
        background-image: url(../../../assets/img/georganiseerd.png);
        background-size: cover;
        background-position: center;
    }

    .wrapblc4 {
        margin-top: 20px;
        background-image: url(../../../assets/img/creatief.png);
        background-size: cover;
        background-position: center;
    }

    .radio-error-message {
        width: 100%;
        margin-top: 0.25rem;
        font-size: 80%;
        font-weight: bold;
        color: #dc3545;
        margin-bottom: 15px;
    }

    .radio-buttons > .col-md-7, .checkboxes > .col-md-7 {
        margin-bottom: 10px;
        padding-top: 5px;
    }
</style>
